<template>
  <div class="vx-row mb-2 -mt-1 dropDown" v-if="showDataField">
    <div class="vx-col" :class="calculateSize">
      <span class="text-xs">{{ fieldLabel }}</span>
      <v-select @search="fetchOptions" class="w-full" :label-placeholder="fieldLabel" name="field"
        v-validate="structure.validation" v-model="selected" :appendToBody="appendToBody"
        :options="$store.state.main.masterCodeWarehouseFilter" :dir="$vs.rtl ? 'rtl' : 'ltr'" />
      <span class="text-danger text-sm" v-show="errors.has('field')">{{
        errors.first("field")
      }}</span>
    </div>
  </div>
</template>
<script>
import vSelect from "vue-select";
import { helperMixin } from "../../../mixin/helperMixin";
import { sidebarMixin } from "../sidebarMixin";
import axios from "@/axios.js";
import { axiosMixin } from "@/mixin/axiosMixin.js";
import { bus } from "../../../main";

export default {
  mixins: [helperMixin, sidebarMixin, axiosMixin],
  components: {
    vSelect,
  },
  props: {
    index: String,
    structure: {
      type: Object,
      default: () => { },
      required: true,
    },
    value: String, // change from Number to String because of PR branch
    validation: "",
    size: String,
    appendToBody: {
      type: Boolean,
      defaul: false,
    },
  },
  data() {
    return {
      selected: this.thevalue,
    };
  },
  methods: {
    fetchOptions(search, loading) {
      loading(true)
      // fetch data from server

      this.aronPost("getMasterCodeBaseOnGasgetType", { gasketType: this.$store.state.main.gasketTypevalue, masterStockCodeKeyword: search }, "", "")
        .then((response) => {
          if (response.status == 200) {
            this.$store.state.main.masterCodeWarehouseFilter = response.data.data;
            loading(false)
          }
        })
        .catch((error) => {
          // this.decodeErrorFromAxios(error);
        });

    }
  },
  computed: {
    thevalue() {
      return this.value != null ? JSON.parse(this.value).id : "";
    },
    calculateSize() {
      return this.size == undefined ? "w-full" : this.size;
    },

    showDataField() {
      return this.showField();
    },
  },
  created() {
    console.log("value:", this.value);
    if (this.value != undefined && this.value != "") {
      this.selected = this.arrayOfObjectFind(
        this.structure.data,
        this.value
      )[0];

      this.$emit("input", { index: this.index, value: this.value });
    } else {
      this.selected = this.arrayOfObjectFind(
        this.structure.data,
        this.structure.value
      )[0];

      console.log("status value:", this.structure.value);
      this.$emit("input", { index: this.index, value: this.structure.value });
    }

    console.log("select selected:", this.selected);

    if (this.selected != "" && this.selected != undefined) {
      this.$emit("error", { index: this.index, value: true });
    }

    this.$watch("selected", (value) => {
      var errorVal = false;
      if (value != null) {
        errorVal = true;
        value = value.id;
      }
      this.$store.state.main.masterStockCodeValue = value;
      this.aronPost("getsubStockCodeBaseOnMasterStockCode", { mtc: value }, "", "")
        .then((response) => {
          if (response.status == 200) {
            this.$store.state.main.subStockCodeFilter = response.data.data;

          }
        })
        .catch((error) => {
          // this.decodeErrorFromAxios(error);
        });

      this.$emit("error", { index: this.index, value: errorVal });
      this.$emit("input", { index: this.index, value: value });
    });

    // this.$watch("$store.state.main.masterCodeWarehouseFilter", (value) => {
    //   this.selected = '';
    // });


  },
};
</script>
<style lang="scss" scoped>
.dropDown {}
</style>
